/* UMI&UMI — desktop mega-menu hover-intent.
   Horizon closes the dropdown on pointerout/pointerleave the instant the cursor crosses the
   ~10px dead gap between a nav item and its full-width panel. The panel's visible links sit far
   left of the centered trigger, so users move diagonally and the pointer briefly leaves the <li>.
   We can't reliably stop Horizon's own handler, and CSS bridges lose to a stacking trap
   (header-component has contain:layout). So we let it close, then — on our OWN listener that runs
   AFTER Horizon's (registered later, same event, before paint = no flicker) — restore the open
   state IF the cursor is still within the trigger -> gap -> panel zone. Restoring = the exact two
   attributes Horizon's "activate" sets: aria-expanded="true" on the link + data-active on the
   submenu. Desktop only; the mobile drawer is a separate accordion and is untouched. */
(function () {
  function inZone(li, x, y) {
    var link = li.querySelector(':scope > a.menu-list__link');
    var mega = li.querySelector('.mega-menu');
    if (!link || !mega) return false;
    var r = link.getBoundingClientRect();
    var p = mega.getBoundingClientRect();
    // Nav row: keep open only over THIS item's own link (so moving to a sibling still closes it).
    if (y >= r.top - 2 && y <= r.bottom + 1) return x >= r.left && x <= r.right;
    // Gap transit strip between the link and the panel: keep open across the panel width.
    if (y > r.bottom + 1 && y <= p.top + 2) return x >= p.left && x <= p.right;
    // Over the panel itself: keep open.
    if (y > p.top && y <= p.bottom + 4) return x >= p.left && x <= p.right;
    return false;
  }

  function reopen(li) {
    var link = li.querySelector(':scope > a.menu-list__link');
    var sub = li.querySelector('.menu-list__submenu');
    if (link) link.setAttribute('aria-expanded', 'true');
    if (sub) sub.setAttribute('data-active', '');
  }

  function attach() {
    var items = document.querySelectorAll('.menu-list__list-item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.__umiHoverIntent) continue;
      var mega = li.querySelector('.mega-menu');
      var link = li.querySelector(':scope > a.menu-list__link');
      if (!mega || !link) continue;            // not a dropdown item
      li.__umiHoverIntent = true;
      (function (li) {
        function guard(e) {
          if (window.innerWidth < 750) return;                 // desktop only
          if (e.relatedTarget && li.contains(e.relatedTarget)) return; // moved within the item
          if (inZone(li, e.clientX, e.clientY)) reopen(li);
        }
        // registered after Horizon's handlers -> runs after them, same event, before paint.
        li.addEventListener('pointerout', guard);
        li.addEventListener('pointerleave', guard);
      })(li);
    }
  }

  if (document.readyState !== 'loading') attach();
  else document.addEventListener('DOMContentLoaded', attach);
  setTimeout(attach, 800);
  setTimeout(attach, 2000);   // re-scan in case the header (overflow-list) re-renders
})();
